<div class="not-found-container">
    <div class="logo">

    </div>
    <h1>404</h1>
    <p>The page you're looking for doesn't exist.</p>
    <a class="go-home" (click)="goHome()">
        <button class="desp-button">Go back to Environments </button>
        </a>
  </div>
